/*
  Zenbean offer widget v3 controller (Sep 2026). Jose's zenbean-offer-widget-v3.html, wired to
  the live buy box. Markup + config: snippets/zb-offer-v3.liquid. Confirmation panel:
  assets/zb-offer-confirm.js.

  ZB_OFFER (the JSON config) is the single source of truth and calc() builds every number the
  page shows. Nothing here is typed copy except the words.

  Events (window):
    zb:offer-change  on every selection change, detail = calc() of the selection
    zb:offer-submit  when Try Risk Free is tapped (cancelable), same detail
    zb:offer-added   after the cart holds exactly that selection; the confirmation panel opens on it

  Cart: Try Risk Free REPLACES any Zenbean offer lines already in the cart (so going back and
  picking another tier never leaves two coffees in checkout), then adds the coffee variant plus
  the tier's gift products. That add is the one Add to Cart event Naeem reads. The gift sets
  must match the two BXGY discounts' "gets" quantities exactly (2 for Buy 3, 3 for Buy 6; 4 and
  5 once the Bundle Savings + Free Shipping lines are on, see cartExtras), or Shopify discounts
  nothing and the customer pays for the gifts.
*/
(function () {
  "use strict";

  var OFFER_ATTRIBUTE = "Offer";

  function init(widget) {
    if (widget.__zbw) return;
    widget.__zbw = true;

    var configEl = widget.querySelector("[data-zbw-config]");
    if (!configEl) return;
    var ZB_OFFER;
    try {
      ZB_OFFER = JSON.parse(configEl.textContent);
    } catch (error) {
      console.error("[zb-offer-v3] bad config", error);
      return;
    }

    var root = document.querySelector('[data-zbpc-hero="' + ZB_OFFER.sectionId + '"]') || widget.closest("[data-zbpc-hero]");
    if (!root) return;

    var state = { format: 0, tier: ZB_OFFER.defaultTier };
    var fmtTiles = root.querySelectorAll('[data-role="fmt-tile"]');
    var cta = root.querySelector("#zbpc-cta-btn") || document.getElementById("zbpc-cta-btn");

    function $(sel) { return widget.querySelector(sel); }
    // Cents in, "$69" / "$69.00" out. short drops ".00" only; "$0.96" keeps its cents.
    function money(cents, full) {
      var n = Math.round(cents) / 100;
      if (full || Math.round(cents) % 100) return "$" + n.toFixed(2);
      return "$" + String(Math.round(n));
    }
    function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
    function fill(str, f) { return str.replace("{unit}", f.unit).replace("{Units}", cap(f.units)).replace("{units}", f.units); }
    function plural(n, word) { return n + " " + word + (n === 1 ? "" : "s"); }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

    /* every number the UI shows comes from here */
    function calc(tierIndex, formatIndex) {
      var t = ZB_OFFER.tiers[tierIndex], f = ZB_OFFER.formats[formatIndex], v = f.variants[tierIndex];
      var coffeeValue = t.units * f.boxPriceCents;
      var coffeeSave = coffeeValue - v.priceCents;
      var gifts = ZB_OFFER.gifts.filter(function (g) { return g.unlockAt <= tierIndex; });
      var giftValue = gifts.reduce(function (s, g) { return s + g.valueCents; }, 0);
      var giftVariantIds = gifts.filter(function (g) { return g.variantId; }).map(function (g) { return g.variantId; });
      // "Bundle Savings" + "Free Shipping" checkout lines (see zb-offer-v3.liquid); [] until switched on.
      var extraIds = (t.cartExtras || []).filter(Boolean);
      return {
        tierIndex: tierIndex, formatIndex: formatIndex,
        name: fill(t.name, f), format: f.name, unit: f.unit, unitsWord: f.units, units: t.units, servings: f.servings,
        formatImg: f.img,
        variantId: v.id, available: !!(v.id && v.available),
        price: v.priceCents, coffeeValue: coffeeValue, coffeeSave: coffeeSave, boxPrice: f.boxPriceCents,
        gifts: gifts, giftIds: giftVariantIds, extraIds: extraIds, giftValue: giftValue,
        totalValue: coffeeValue + giftValue,
        totalSave: coffeeSave + giftValue,
        perServing: v.priceCents / (t.units * f.servings),
        offerLabel: ZB_OFFER.offerLabel, offerKey: ZB_OFFER.offerKey,
        money: { price: money(v.priceCents), priceFull: money(v.priceCents, true), totalValue: money(coffeeValue + giftValue), totalSave: money(coffeeSave + giftValue) }
      };
    }

    var checkSvg = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6l3 3 5-5" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var lockSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5zm-3 8V7a3 3 0 0 1 6 0v3H9z"/></svg>';

    function renderTiers() {
      var f = ZB_OFFER.formats[state.format];
      $("[data-zbw-tiers]").innerHTML = ZB_OFFER.tiers.map(function (t, i) {
        var c = calc(i, state.format);
        var giftLine = i === ZB_OFFER.tiers.length - 1 ? "Unlock All " + c.gifts.length + " Free Gifts" : "Unlock " + plural(c.gifts.length, "Free Gift");
        var hasDeal = c.coffeeSave > 0;
        return '<button type="button" class="zbw-tier" role="radio" aria-checked="' + (i === state.tier) + '" data-zbw-tier="' + i + '">' +
          (t.flag ? '<span class="zbw-tier-flag ' + (t.flagStyle || "") + '">' + esc(t.flag) + "</span>" : "") +
          '<div class="zbw-row"><div class="zbw-left">' +
            '<span class="zbw-check">' + checkSvg + "</span>" +
            '<div><p class="zbw-name">' + esc(fill(t.name, f)) + "</p>" +
            '<p class="zbw-gcount">' + giftLine + "</p></div>" +
          '</div><div class="zbw-right">' +
            (hasDeal ? '<span class="zbw-save ' + (t.pill || "") + '">Save ' + money(c.totalSave) + "</span>" : "") +
            '<div class="zbw-prices"><span class="zbw-price">' + money(c.price) + "</span>" +
            (hasDeal ? '<span class="zbw-compare-wrap"><s class="zbw-compare">' + money(c.totalValue) + "</s> value</span>" : "") + "</div>" +
            '<p class="zbw-per">' + money(c.perServing, true) + " per serving</p>" +
          "</div></div></button>";
      }).join("");
    }

    function renderGifts() {
      var total = ZB_OFFER.gifts.reduce(function (s, g) { return s + g.valueCents; }, 0);
      var f = ZB_OFFER.formats[state.format];
      $("[data-zbw-gifts-sub]").textContent = "Up to " + money(total) + " in free gifts today. The bigger the pack, the more you unlock.";
      $("[data-zbw-gifts]").innerHTML = ZB_OFFER.gifts.map(function (g) {
        var locked = g.unlockAt > state.tier;
        var need = ZB_OFFER.tiers[g.unlockAt];
        var lockLabel = need.units + (g.unlockAt < ZB_OFFER.tiers.length - 1 ? "+ " : " ") + (need.units === 1 ? f.unit : f.units);
        return '<div class="zbw-gift' + (locked ? " is-locked" : "") + '">' +
          '<span class="zbw-gift-badge">FREE <s>' + money(g.valueCents) + "</s></span>" +
          '<div class="zbw-gift-img"><img src="' + esc(g.img) + '" alt="' + esc(g.name) + '" loading="lazy" decoding="async">' +
            '<div class="zbw-lock">' + lockSvg + "<span>" + lockLabel + "</span></div></div>" +
          '<p class="zbw-gift-name">' + esc(g.name) + "</p></div>";
      }).join("");

      var nudge = $("[data-zbw-nudge]");
      var next = state.tier + 1;
      if (next < ZB_OFFER.tiers.length) {
        var gained = ZB_OFFER.gifts.filter(function (g) { return g.unlockAt === next; });
        var what = gained.length === 1 ? "the free " + gained[0].name.replace("Coffee ", "").toLowerCase() : gained.length + " more free gifts";
        nudge.textContent = "Choose " + ZB_OFFER.tiers[next].units + " " + f.units + " to unlock " + what;
        nudge.classList.remove("done");
        nudge.disabled = false;
        nudge.setAttribute("data-next", String(next));
      } else {
        nudge.textContent = "All " + ZB_OFFER.gifts.length + " free gifts unlocked";
        nudge.classList.add("done");
        nudge.disabled = true;
      }
    }

    function renderSummary() {
      var c = calc(state.tier, state.format);
      var hasDeal = c.coffeeSave > 0;

      // Top price row under the title (replaces the old "SUMMER SALE - SAVE 21%" pill).
      var topPrice = root.querySelector('[data-role="top-price"]');
      var topValue = root.querySelector("[data-zbw-top-value]");
      var topCompare = root.querySelector('[data-role="top-compare-price"]');
      var topPill = root.querySelector("[data-zbw-top-pill]");
      if (topPrice) topPrice.textContent = money(c.price, true);
      if (topCompare) topCompare.textContent = money(c.totalValue, true);
      if (topValue) topValue.hidden = !hasDeal;
      if (topPill) { topPill.textContent = "Save " + money(c.totalSave) + " today"; topPill.hidden = !hasDeal; }

      $("[data-zbw-saving-main]").textContent = "You're saving " + money(c.totalSave) + " on this order";
      var parts = [];
      if (c.coffeeSave > 0) parts.push(money(c.coffeeSave) + " off your coffee");
      var physical = c.gifts.filter(function (g) { return g.key !== "shipping"; });
      parts.push(physical.length ? money(c.giftValue) + " in free gifts" : "Free shipping included");
      $("[data-zbw-saving-break]").textContent = parts.join(" + ");

      // CTA: "Try risk free for $69", greyed out if that variant cannot be bought.
      if (cta) {
        var ctaPrice = cta.querySelector('[data-role="cta-price"]');
        if (ctaPrice) ctaPrice.textContent = money(c.price);
        var buy = cta.querySelector('[data-role="cta-buy"]');
        var sold = cta.querySelector('[data-role="cta-soldout"]');
        if (buy) buy.style.display = c.available ? "" : "none";
        if (sold) sold.style.display = c.available ? "none" : "";
        cta.disabled = !c.available;
        cta.setAttribute("aria-disabled", c.available ? "false" : "true");
        cta.style.cursor = c.available ? "pointer" : "not-allowed";
        cta.style.setProperty("background-color", c.available ? "#C8102E" : "#B9AFA4", "important");
      }

      // Sticky bars (#zbpc-sticky-*). tof-sticky-bar mirrors these into the desktop bar.
      var label = document.getElementById("zbpc-sticky-label");
      var price = document.getElementById("zbpc-sticky-price");
      var orig = document.getElementById("zbpc-sticky-orig");
      var save = document.getElementById("zbpc-sticky-save");
      if (label) label.textContent = c.format + " · " + c.name;
      if (price) price.textContent = money(c.price);
      if (orig) {
        orig.style.textDecoration = "none";
        orig.innerHTML = hasDeal ? '<span style="text-decoration:line-through;">' + money(c.totalValue) + "</span> value" : "";
      }
      if (save) save.textContent = hasDeal ? "Save " + money(c.totalSave) : "";
      // The TOF desktop bar copies #zbpc-sticky-orig's TEXT into a span that is struck through
      // as a whole, which would strike "value" too. Repaint it after that copy has run.
      setTimeout(function () {
        document.querySelectorAll('.tof-dsticky [data-role="orig"]').forEach(function (el) {
          el.style.textDecoration = "none";
          el.innerHTML = hasDeal ? '<span style="text-decoration:line-through;">' + money(c.totalValue) + "</span> value" : "";
        });
      }, 0);

      if (typeof root.zbpcSetGallery === "function") root.zbpcSetGallery(state.format, state.tier > 0 ? 1 : 0);

      window.ZB_OFFER_STATE = c;
      window.dispatchEvent(new CustomEvent("zb:offer-change", { detail: c }));
    }

    function render() { renderTiers(); renderGifts(); renderSummary(); }

    function selectTier(i) {
      if (!ZB_OFFER.tiers[i]) return;
      state.tier = i;
      render();
    }

    widget.addEventListener("click", function (e) {
      var tier = e.target.closest("[data-zbw-tier]");
      var nud = e.target.closest("[data-zbw-nudge]");
      if (tier) {
        selectTier(Number(tier.getAttribute("data-zbw-tier")));
        var again = widget.querySelector('[data-zbw-tier="' + state.tier + '"]');
        if (again) again.focus({ preventScroll: true });
      }
      if (nud && !nud.disabled) selectTier(Number(nud.getAttribute("data-next")));
    });

    // Arrow keys move through the plan radiogroup.
    widget.addEventListener("keydown", function (e) {
      var group = e.target.closest('[role="radiogroup"]');
      if (!group || ["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"].indexOf(e.key) < 0) return;
      e.preventDefault();
      var items = [].slice.call(group.querySelectorAll('[role="radio"]'));
      var i = items.indexOf(e.target.closest('[role="radio"]'));
      var n = items[(i + (e.key === "ArrowDown" || e.key === "ArrowRight" ? 1 : -1) + items.length) % items.length];
      n.click();
    });

    fmtTiles.forEach(function (tile) {
      tile.addEventListener("click", function () {
        state.format = Number(tile.getAttribute("data-index")) || 0;
        fmtTiles.forEach(function (other) {
          var on = other === tile;
          other.classList.toggle("zbpc-active", on);
          var name = other.querySelector('[data-role="fmt-name"]');
          if (name) name.style.color = on ? "#A00D25" : "#1A0F0A";
        });
        render();
      });
    });

    /* ---------------- cart ---------------- */

    function postJson(url, body) {
      return fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok) throw new Error((json && (json.description || json.message)) || "Cart request failed");
          return json;
        });
      });
    }

    var OFFER_VARIANTS = {};
    ZB_OFFER.formats.forEach(function (f) { f.variants.forEach(function (v) { if (v.id) OFFER_VARIANTS[v.id] = true; }); });

    // A Zenbean offer line (coffee or its gift) from this widget or the control widget.
    function isOfferLine(item) {
      var p = item.properties || {};
      return !!(OFFER_VARIANTS[item.variant_id] || p._zenbean_welcome_kit || p._zenbean_welcome_gift);
    }

    function includesNote(c) {
      var names = c.gifts.map(function (g) { return g.name; });
      var units = c.units === 1 ? "1 " + c.unit : c.units + " " + c.unitsWord;
      return units + " + free gifts: " + names.join(", ");
    }

    // Replaces the cart's Zenbean offer lines with exactly this selection.
    function buildCart(c) {
      return fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var updates = {};
          (cart.items || []).forEach(function (item) { if (isOfferLine(item)) updates[item.key] = 0; });
          return Object.keys(updates).length ? postJson("/cart/update.js", { updates: updates }) : null;
        })
        .then(function () {
          var parent = String(c.variantId);
          var items = [{
            id: c.variantId,
            quantity: 1,
            properties: { _zenbean_welcome_kit: "true", Includes: includesNote(c), _offer: c.offerKey }
          }];
          c.giftIds.forEach(function (id) {
            items.push({ id: id, quantity: 1, properties: { Type: "Free gift with your order", _zenbean_welcome_gift: "true", _zenbean_parent_variant: parent } });
          });
          // No visible "Type": checkout shows these by their own titles. The gift marker lets
          // zen-gift-guard.js drop them with the coffee and isOfferLine() replace them.
          (c.extraIds || []).forEach(function (id) {
            items.push({ id: id, quantity: 1, properties: { _zenbean_welcome_gift: "true", _zenbean_offer_line: "extra", _zenbean_parent_variant: parent } });
          });
          // Coffee first: it is the one Add to Cart; the gifts go in without one (zen-cart-add.js).
          return window.ZenCartAdd ? window.ZenCartAdd.add(items) : postJson("/cart/add.js", { items: items });
        })
        .then(function () {
          var attributes = {};
          attributes[OFFER_ATTRIBUTE] = c.offerLabel;
          return postJson("/cart/update.js", { attributes: attributes });
        });
    }

    function setBusy(on) {
      if (!cta) return;
      cta.disabled = on;
      cta.style.opacity = on ? ".7" : "";
    }

    if (cta) {
      cta.addEventListener("click", function (event) {
        event.preventDefault();
        var c = calc(state.tier, state.format);
        if (!c.available || cta.getAttribute("aria-busy") === "true") return;
        var ev = new CustomEvent("zb:offer-submit", { detail: c, cancelable: true });
        window.dispatchEvent(ev);
        if (ev.defaultPrevented) return;
        cta.setAttribute("aria-busy", "true");
        setBusy(true);
        buildCart(c)
          .then(function () {
            window.dispatchEvent(new CustomEvent("zb:offer-added", { detail: c }));
            // No confirmation panel on the page (should not happen): go straight to checkout.
            if (!window.ZBConfirm) window.location.href = "/checkout";
          })
          .catch(function (error) {
            console.error(error);
            alert("Sorry, something went wrong adding this to your cart:\n\n" + error.message + "\n\nPlease try again or contact support.");
          })
          .then(function () {
            cta.removeAttribute("aria-busy");
            setBusy(false);
          });
      });
    }

    // Used by the confirmation panel (Upgrade re-selects Buy 3 here so both screens agree).
    window.ZBOffer = {
      config: ZB_OFFER,
      calc: calc,
      money: money,
      state: function () { return { tier: state.tier, format: state.format }; },
      selectTier: selectTier,
      buildCart: buildCart
    };

    render();
    widget.setAttribute("data-zbw-ready", "true");

    // A Try Risk Free tap that landed before this script ran (see zb-offer-v3.liquid).
    if (cta && window.__zbwEarly && window.__zbwEarly.pending) {
      window.__zbwEarly.pending = false;
      cta.style.opacity = "";
      cta.click();
    }
  }

  function boot() { document.querySelectorAll("[data-zbw]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
